import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/tatouage')({
  component: () => <Outlet />,
});
